module.exports = __webpack_public_path__ + "static/media/store.f28bb175.svg";